<template>
  <div
    v-if="loading"
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
  >
    <div class="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
      <ProgressSpinner
        :style="{ width: '50px', height: '50px' }"
        strokeWidth="4"
        animationDuration=".8s"
        class="text-pink-600"
      />
      <span class="mt-3 text-gray-700">{{ message || 'Loading...' }}</span>
    </div>
  </div>
</template>

<script>
import ProgressSpinner from 'primevue/progressspinner';
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'LoadingSpinner',
  components: {
    ProgressSpinner,
  },
  props: {
    message: {
      type: String,
      default: '',
    },
    moduleNamespace: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const store = useStore();

    const loading = computed(() => {
      if (props.moduleNamespace) {
        return store.state[props.moduleNamespace].loading;
      }
      return store.state.loading;
    });

    return {
      loading,
    };
  },
};
</script>
